<template>
  <b-form-group
    :label="label">
    <b-form-input
      :ref="`ref${name}`"
      type="text"
      :name="name"
      :placeholder="placeholder"
      :disabled="disabled"
      :state="verificaEstadoInput()"
      v-mask="mascara"
      v-model="valor"
      @input="onStateInput($event, 'onInput')"
      @change="onStateInput($event, 'onChange')"
      @update="onStateInput($event, 'onUpdate')"
      @blur="$emit('blur')"
      autocomplete="off"
    />
    <b-form-invalid-feedback>
      {{ retornaMensagemDeErro() }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group'
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input'
import bFormInvalidFeedback from 'bootstrap-vue/es/components/form/form-invalid-feedback'
import { mask } from 'vue-the-mask'
import InputBaseMixins from '../mixins/InputBaseMixins'

export default {
  name: 'InputTelefone',
  mixins: [InputBaseMixins],
  components: {
    bFormGroup,
    bFormInput,
    bFormInvalidFeedback,
  },
  directives: {
    mask,
  },
  data() {
    return {
      mascara: '+55 (##)# ####-####',
    }
  },
}
</script>
